import { initAuditSdk } from '@oolio-group/audit-sdk';
import config from '../config';
import { sessionSubject } from '../state/sessionObservable';
import Sentry from '../utils/Sentry/Sentry';

export * from '@oolio-group/audit-sdk';

const isDevelopment =
  (process.env['REACT_APP_LOGGING_ENV'] || process.env.NODE_ENV) ===
  'development';

export function initActionLogging(): void {
  initAuditSdk({
    serviceUrl: config.AUDIT_SVC_URL,
    deviceType: 'CDS',
    getAuthToken: () => sessionSubject.getValue()?.token ?? null,
    onError: (error, tags) => Sentry.captureException(error, { tags }),
    enableConsoleOutput: isDevelopment,
    minLogLevel: isDevelopment ? 'debug' : 'info',
    debugSql: isDevelopment,
    webDbName: 'cds-app',
  });
}
